'use strict';

exports.__esModule = true;
exports.calcOptionsLength = calcOptionsLength;
exports.flattenGroupedChildren = flattenGroupedChildren;
exports.isFocused = isFocused;
exports.getCurrentIndex = getCurrentIndex;
exports.createGetHeight = createGetHeight;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function calcOptionsLength(options) {
  options = options || [];
  var head = options[0] || {};
  var isGrouped = head.options !== undefined;

  return isGrouped ? options.reduce(function (result, group) {
    return result + group.options.length;
  }, 0) : options.length;
}

function flattenGroupedChildren(children) {
  return children.reduce(function (result, child) {
    var _child$props$children = child.props.children,
        nestedChildren = _child$props$children === undefined ? [] : _child$props$children;


    return [].concat(result, [_react2.default.cloneElement(child, { type: 'group' }, [])], nestedChildren);
  }, []);
}

function isFocused() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$props = _ref.props;

  _ref$props = _ref$props === undefined ? {} : _ref$props;
  var isFocused = _ref$props.isFocused;

  return isFocused === true;
}

function getCurrentIndex(children) {
  return Math.max(children.findIndex(isFocused), 0);
}

function createGetHeight() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      groupHeadingStyles = _ref2.groupHeadingStyles,
      noOptionsMsgStyles = _ref2.noOptionsMsgStyles,
      optionStyles = _ref2.optionStyles,
      loadingMsgStyles = _ref2.loadingMsgStyles;

  return function getHeight() {
    var child = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _child$props = child.props;
    _child$props = _child$props === undefined ? {} : _child$props;
    var type = _child$props.type,
        children = _child$props.children,
        _child$props$selectPr = _child$props.selectProps;
    _child$props$selectPr = _child$props$selectPr === undefined ? {} : _child$props$selectPr;
    var noOptionsMessage = _child$props$selectPr.noOptionsMessage,
        loadingMessage = _child$props$selectPr.loadingMessage;


    if (type === 'group') {
      var _groupHeadingStyles$h = groupHeadingStyles.height,
          height = _groupHeadingStyles$h === undefined ? 25 : _groupHeadingStyles$h;

      return height;
    } else if (type === 'option') {
      var _optionStyles$height = optionStyles.height,
          _height = _optionStyles$height === undefined ? 35 : _optionStyles$height;

      return _height;
    } else if (typeof noOptionsMessage === 'function' && children === noOptionsMessage()) {
      var _noOptionsMsgStyles$h = noOptionsMsgStyles.height,
          _height2 = _noOptionsMsgStyles$h === undefined ? 35 : _noOptionsMsgStyles$h;

      return _height2;
    } else if (typeof loadingMessage === 'function' && children === loadingMessage()) {
      var _loadingMsgStyles$hei = loadingMsgStyles.height,
          _height3 = _loadingMsgStyles$hei === undefined ? 35 : _loadingMsgStyles$hei;

      return _height3;
    } else {
      return 35;
    }
  };
}